<script setup>
import { useSlots } from 'vue'

const slots = useSlots()
</script>
<template>
  <div class="flex flex-col xl:w-[1000px] my-6 p-1 gap-1 bg-slate-100">
    <slot
      v-if="slots.data"
      name="data"
    />
    <slot
      v-if="slots.status"
      name="status"
    />
    <slot
      v-if="slots.toolbar"
      name="toolbar"
    />
  </div>
</template>
